import { useNavigate } from "react-router-dom";
import "../../styles/home/features.css";
import "../../styles/home/hero.css";

const Features = () => {
  const navigate = useNavigate();
  const handleExplore = () => {
    navigate("/visualizations");
  };

  return (
    <section className="features">
      <div className="features-header">
        <h2>Learn concepts the way your brain understands them</h2>
        <p>
          VisualLab turns complex topics into step-by-step visual explanations.
        </p>
      </div>

      <div className="features-container">
        <div className="feature-card">
          <div className="icon">👁️</div>
          <h3>Learn Visually</h3>
          <p>
            Step-by-step visual breakdowns of complex topics instead of long
            text.
          </p>
        </div>

        <div className="feature-card">
          <div className="icon">🧠</div>
          <h3>Deep Understanding</h3>
          <p>Understand why things work, not just how to memorize them.</p>
        </div>

        <div className="feature-card coming-soon">
          <span className="badge">Coming Soon</span>
          <div className="icon">🚀</div>
          <h3>Publish & Teach</h3>
          <p>Create and publish your own visual explanations for others.</p>
        </div>
      </div>
      <button onClick={handleExplore} className="primary-btn">
        Ready to learn visually?
      </button>
    </section>
  );
};

export default Features;
